/*
 * @format
 */

import React from 'react';

import Steps from './Steps';
import { CHOOSE_MODE, OPEN_MODE_PICKER } from './copy';
import WatchModeTapDiagram from './WatchModeTapDiagram';
import WatchModeListDiagram from './WatchModeListDiagram';

/*
 * Changing mode takes two screens on the watch — open the mode picker from the
 * zone screen, then choose a mode — so the topic is told as two steps, one
 * screen each, rather than as one page carrying both pictures.
 *
 * The sentences are split over the steps they belong to instead of both steps
 * repeating the whole paragraph: the reader is being told what to do on the
 * screen in front of them. They are the same two the Plus Hours topic opens
 * with, since they describe the same two watch screens.
 *
 * Manual is the row pointed at rather than Plus Hours: the example zone is on
 * Auto, so Manual reads as an ordinary change of mode, and Plus Hours has a
 * topic of its own that would otherwise be told twice.
 */
const steps = [
  {
    body: OPEN_MODE_PICKER,
    diagram: <WatchModeTapDiagram />,
  },
  {
    body: CHOOSE_MODE,
    diagram: <WatchModeListDiagram target="Manual" />,
  },
];

function WatchAppHelpModesScreen({ navigation }) {
  return (
    <Steps
      title="Changing heating mode"
      steps={steps}
      navigation={navigation}
    />
  );
}

export default WatchAppHelpModesScreen;
